import type { SearchModalSection } from '@common/components/SearchModal/search-modal.interface'

import type { AcademySearchApiPayload } from '@/lib/academySearch/academySearch.interface'

import { SEARCH_MODAL_FILTER_CHIP_IDS } from '../search-modal.const'
import type { SearchModalFilterChipId } from '../search-modal.type'
import { getSearchModalFilterChipLabel } from '../search-modal.utils'

import { mapDocumentation } from './mapDocumentation'
import { mapGlossary } from './mapGlossary'
import { mapQuickStart } from './mapQuickStart'

/** Maps API payload into `SearchModal` sections for the active tab and query string. */
export function buildSearchModalSections(
  filterChipId: SearchModalFilterChipId,
  queryTrimmed: string,
  payload: AcademySearchApiPayload
): SearchModalSection[] {
  let sections: SearchModalSection[]

  switch (filterChipId) {
    case SEARCH_MODAL_FILTER_CHIP_IDS.quickStart: {
      const title = queryTrimmed
        ? 'Matching articles'
        : getSearchModalFilterChipLabel(SEARCH_MODAL_FILTER_CHIP_IDS.quickStart)

      sections = [
        {
          id: 'academy-quick-start',
          title,
          items: payload.quickStart.map((row) => mapQuickStart(row, queryTrimmed)),
        },
      ]
      break
    }

    case SEARCH_MODAL_FILTER_CHIP_IDS.documents:
      sections = [
        {
          id: 'academy-documentation-results',
          title: getSearchModalFilterChipLabel(SEARCH_MODAL_FILTER_CHIP_IDS.documents),
          items: payload.documentation.map((row) => mapDocumentation(row, queryTrimmed)),
        },
      ]
      break

    case SEARCH_MODAL_FILTER_CHIP_IDS.glossary:
      sections = [
        {
          id: 'academy-glossary-results',
          title: getSearchModalFilterChipLabel(SEARCH_MODAL_FILTER_CHIP_IDS.glossary),
          items: payload.glossary.map((row) => mapGlossary(row, queryTrimmed)),
        },
      ]
      break

    default:
      sections = [
        {
          id: 'academy-quick-start-results',
          title: getSearchModalFilterChipLabel(SEARCH_MODAL_FILTER_CHIP_IDS.quickStart),
          items: payload.quickStart.map((row) => mapQuickStart(row, queryTrimmed)),
        },
        {
          id: 'academy-documentation-results',
          title: getSearchModalFilterChipLabel(SEARCH_MODAL_FILTER_CHIP_IDS.documents),
          items: payload.documentation.map((row) => mapDocumentation(row, queryTrimmed)),
        },
        {
          id: 'academy-glossary-results',
          title: getSearchModalFilterChipLabel(SEARCH_MODAL_FILTER_CHIP_IDS.glossary),
          items: payload.glossary.map((row) => mapGlossary(row, queryTrimmed)),
        },
      ]
  }

  if (queryTrimmed.length === 0) {
    return sections
  }

  return sections.filter((section) => section.items.length > 0)
}
